import { Component, ElementRef, HostListener, Input, Self } from '@angular/core';
import { CybersocxdrglobalfiltersService } from '../../cybersocxdrglobalfilters.service';

export interface MenuItem {
  text: string;
  handler: (point: FilterEvent) => void;
  icon?: string;
}

export interface FilterEvent {
  primary: FilterEventItem;
  secondary?: FilterEventItem;
}

export interface FilterEventItem {
  key: string;
  value: string | number | [string, string]; // logic values
  valueFormat: string; // display value
}

@Component({
  selector: 'app-filtermenu',
  templateUrl: './filtermenu.component.html',
  styleUrls: ['./filtermenu.component.scss'],
})
export class FiltermenuComponent {
  static activemenu = undefined;
  @Input() items: MenuItem[];
  @Input() disabled = false;

  isMenuVisible: boolean;
  rightClickMenuPositionX: number;
  rightClickMenuPositionY: number;
  filter: FilterEvent = {
    primary: {
      key: 'groupLevel1', // Only filtering by 'countries' is supported for now.
      value: undefined,
      valueFormat: undefined,
    },
    secondary: undefined,
  };
  valuesMapping: [string, [string, boolean][]][];

  constructor(
    private globalFilters: CybersocxdrglobalfiltersService,
    @Self() public element: ElementRef<HTMLDivElement>
  ) {}

  @HostListener('document:click')
  @HostListener('window:scroll', ['$event'])
  closeMenu(): void {
    this.isMenuVisible = false;
  }

  onRightClick(event: any) {
    if (this.disabled) {
      return;
    }
    // This is hacky and could break with an update to highcharts.
    const pointName =
      event.target.point?.realName ||
      event.target.point?.name ||
      event.target.point?.series?.name ||
      event.target.parentNode?.point?.name;

    if (pointName === undefined) {
      return;
    }
    event.preventDefault();

    this.rightClickMenuPositionX = event.clientX;
    this.rightClickMenuPositionY = event.clientY;

    this.filter.primary = this.toFilter(pointName);
    if (this.filter.primary === undefined) {
      // it's a repartition chart
      this.filter.primary = {
        key: undefined,
        value: pointName,
        valueFormat: pointName,
      };
      this.filter.primary.value = pointName;
    }

    this.filter.secondary = undefined;

    const seriesName = event.target.point?.series?.name;
    const time = event.target.point?.options?.x;
    const timeInterval = event.target.point?.series?.xAxis?.tickInterval;

    if (seriesName && seriesName !== pointName) {
      this.filter.secondary = this.toFilter(seriesName);
    } else if (time && timeInterval) {
      // time filter is special...
      const timeStart = time;
      const timeEnd = time + timeInterval;
      const timeStartValue = new Date(timeStart).toISOString().split('T')[0];
      const timeEndValue = new Date(timeEnd).toISOString().split('T')[0];
      const timeStartFormat = new Date(timeStart).toLocaleDateString();
      const timeEndFormat = new Date(timeEnd).toLocaleDateString();
      const timeFormat = `${timeStartFormat} - ${timeEndFormat}`;
      this.filter.secondary = {
        key: 'time',
        value: [timeStartValue, timeEndValue],
        valueFormat: timeFormat,
      };
    }

    if (FiltermenuComponent.activemenu) {
      FiltermenuComponent.activemenu.isMenuVisible = false;
    }
    FiltermenuComponent.activemenu = this;
    this.isMenuVisible = true;
  }

  toFilter(raw: string): FilterEventItem | undefined {
    let i: number;
    let result: FilterEventItem;
    const valuesMapping: [string, [string, boolean][]][] = [
      ['status', this.globalFilters.status],
      ['owners', this.globalFilters.owners],
      ['categories', this.globalFilters.categories],
      // Severity is special... Critical is actually called Business critical
      [
        'severitys',
        [
          ['Low', false],
          ['Medium', false],
          ['High', false],
          ['Business critical', false],
        ],
      ],
    ];
    for (const [key, values] of valuesMapping) {
      if ((i = values.findIndex((e) => e[0].toLowerCase() === raw.toLowerCase())) !== -1) {
        result = {
          key,
          value: i,
          valueFormat: raw,
        };
      }
    }
    return result;
  }

  getRightClickMenuStyle() {
    return {
      position: 'fixed',
      left: `${this.rightClickMenuPositionX}px`,
      top: `${this.rightClickMenuPositionY}px`,
    };
  }

  onMenuClick(_event: any, menuItem: MenuItem) {
    menuItem.handler(this.filter);
  }
}
